<template>
  <v-card>
    <v-container class="pa-3" fluid>
      <v-layout
        class="mb-3 text-xs-center grey lighten-2"
        row
        align-center
        justify-center
        align-content-center
      >
        <v-flex class="mr-1" shrink>
          <v-icon>event</v-icon>
        </v-flex>
        <v-flex shrink>
          <h1 class="subtle all-caps">Events</h1>
        </v-flex>
      </v-layout>
      <v-layout column>
        <v-list two-line>
          <v-list-tile v-for="i in invites" :key="i.event_id">
            <v-list-tile-content>
              <v-list-tile-title>
                <span class="mr-2">
                  <router-link :to="{ name: 'eventDetail', params: { eventId: i.event_id } }" target="_blank">{{ i.event_title }}</router-link>
                </span>
                <span>{{ i.event_date | moment("dddd, MMMM D YYYY") }}</span>
              </v-list-tile-title>
              <v-list-tile-sub-title>
                RSVP:
                <span v-if="i.responded">
                  <v-chip outline small color="success" v-if="i.attending">
                    GOING
                  </v-chip>
                  <v-chip outline small color="error" v-if="!i.attending">
                    NOT GOING
                  </v-chip>
                </span>
                <span v-else>
                  <router-link :to="{ name: 'eventDetail', params: { eventId: i.event_id } }" target="_blank">
                    <v-tooltip top>
                      <v-chip outline small slot="activator" style="cursor: pointer;">
                        Haven't responded
                      </v-chip>
                      <span>Submit RSVP</span>
                    </v-tooltip>
                  </router-link>
                </span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-layout>

    </v-container>
  </v-card>
</template>

<script>

  import inviteApi from '@/api/invites';

  export default {
    created() {
      this.fetchInvites();
    },
    components: {
    },
    computed: {
    },
    data: function() {
      return {
        invites: [],
      };
    },
    methods: {
      fetchInvites() {
        inviteApi.getMine(invites => {
          this.invites = invites
        })
      },
    },
  };
</script>
